import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for fetching sample users
export const fetchSampleUsers = createAsyncThunk(
  'sampleUsers/fetchSampleUsers',
  async ({ filters, pagination }, thunkAPI) => {
    const { user_name, user_email, createdAt } = filters;
    const { currentPage, pageSize } = pagination;

    try {
      const response = await axios.get('/api/download-sample-users', {
        params: { user_name, user_email, createdAt, page: currentPage, pageSize },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error fetching data');
    }
  }
);

// Async thunk for fetching event users
export const fetchAddEventUsers = createAsyncThunk(
  'sampleUsers/fetchAddEventUsers',
  async ({ filters, pagination }, thunkAPI) => {
    try {
      const response = await axios.get('/api/get-event-user', {
        params: { 
          //user_name: filters.user_name, 
          page: pagination.currentPage, 
          pageSize: pagination.pageSize,
          ...filters
        },
      });
      console.log("response add event user",response.data);
      return response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error fetching event users');
    }
  }
);


// Async thunk for deleting a sample user
export const deleteSampleUser = createAsyncThunk(
  'sampleUsers/deleteSampleUser',
  async (ids, thunkAPI) => {
    try {
      const respose = await axios.delete(`/api/delete-download-sample-user/`, {
        data: { ids }, 
      });
      console.log("response from delete sample user",respose.data.message);
      return respose.data.message; // Return the response data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error deleting user');
    }
  }
);


const sampleUsersSlice = createSlice({
  name: 'sampleUsers',
  initialState: {
    data: [], // Sample users list
    eventUsers: [], // Event users list
    filters: { user_name: '', user_email: '', createdAt: '' },
    pagination: {
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
    },
    eventPagination: {
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
    },
    status: 'idle',
    error: null,
  },
  reducers: {
    setFilters(state, action) {
      state.filters = action.payload;
    },
    setPagination(state, action) {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setEventPagination(state, action) {
      state.eventPagination = { ...state.eventPagination, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch sample users
      .addCase(fetchSampleUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSampleUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.data;
        state.pagination.totalCount = action.payload.pagination.totalCount;
      })
      .addCase(fetchSampleUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      
      // Fetch event users
      .addCase(fetchAddEventUsers.pending, (state) => {
        state.status = 'loading';
      })
      // Fetch event users
      .addCase(fetchAddEventUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (Array.isArray(action.payload.data)) {
            state.eventUsers = action.payload.data;
        } else {
            state.eventUsers = []; // Ensure it remains an array
        }
        state.eventPagination.totalCount = action.payload.totalRecords || 0;
        state.eventPagination.totalPages = action.payload.totalPages || 1;
    })
    .addCase(fetchAddEventUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.message || 'Something went wrong';
        state.eventUsers = []; // Reset users on error
    })

      // Delete user
      .addCase(deleteSampleUser.fulfilled, (state, action) => {
        state.status = 'Succeeded';
        
      });
  },
});

export const { setFilters, setPagination, setEventPagination } = sampleUsersSlice.actions;
export default sampleUsersSlice.reducer;
